module.exports = __webpack_public_path__ + "img/scroll-5.d409e928.jpg";